import { createSlice } from "@reduxjs/toolkit";
import { getExternalIntegrationConfig, updateExternalIntegrationConfig, createIntegrationConfig } from "./external-integration-config.thunk";

const initialState: {
  data: {
    total: number;
    data: any[];
  };
  loading: boolean;
  error: string | null;
  updatingIds?: string[];
} = {
  data: {
    total: 0,
    data: [],
  },
  loading: false,
  error: null,
  updatingIds: [], // Optional: to track which IDs are being updated
};

const externalIntegrationConfigSlice = createSlice({
  name: "externalIntegrationConfig",
  initialState,
  reducers: {
    setExternalIntegrationConfigs: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExternalIntegrationConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExternalIntegrationConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getExternalIntegrationConfig.rejected, (state, action) => {
        state.loading = false;
        if (action.error.message) {
          state.error = (action.error.message as string) || "Failed to fetch external integration configs";
        }
      })

      //Update external integration config
      .addCase(updateExternalIntegrationConfig.pending, (state, action) => {
        const integrationId = action.meta.arg.integrationId;
        if (integrationId && !state.updatingIds?.includes(integrationId)) {
          state.updatingIds = [...(state.updatingIds || []), integrationId];
        }
      })
      .addCase(updateExternalIntegrationConfig.fulfilled, (state, action) => {
        const updatedConfig = action.payload;

        const integrationId = action.meta.arg.integrationId;
        if (integrationId) {
          state.updatingIds = state.updatingIds?.filter((id) => id !== integrationId);
        }
        // Update the specific integration config in the state
        const index = state.data.data.findIndex((config) => config._id === updatedConfig._id);
        if (index !== -1) {
          state.data.data[index] = updatedConfig;
        } else {
          state.data.data.push(updatedConfig); // If not found, add it
        }
        state.loading = false;

        state.error = null; // Clear error on success
      })
      .addCase(updateExternalIntegrationConfig.rejected, (state, action) => {
        state.loading = false;
        if (action.error.message) {
          state.error = (action.error.message as string) || "Failed to update external integration config";
        }
      })

      .addCase(createIntegrationConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(createIntegrationConfig.fulfilled, (state, action) => {
        state.loading = false;
        const newConfig = action.payload;

        // Add the new config to the state
        state.data.data.push(newConfig);
        state.data.total += 1; // Increment total count
        state.error = null; // Clear error on success
      })
      .addCase(createIntegrationConfig.rejected, (state, action) => {
        state.loading = false;
        if (action.error.message) {
          state.error = (action.error.message as string) || "Failed to create external integration config";
        }
      })



  },
});

export const { setExternalIntegrationConfigs } = externalIntegrationConfigSlice.actions;
export default externalIntegrationConfigSlice.reducer;
